<template>
	<div class="permission">
		<div class="permission-item permission-item1">
			<div class="title">每日查看政策条数不限
			</div>
			<div  class="desc">每天可以查看与您企业精准匹配的全部适时补贴优惠政策，不再错过小到几千元，大到几百万元的政策性补贴</div>
			<img class="label" src="../../../assets/img/vip/permission_img01.png">
			<img class="vip-logo" src="../../../assets/img/vip/permission_img02.png">
		</div>
		<div class="permission-item permission-item2">
			<div class="title">每日仅限查看{{ number || noVipPolicyDayVisitTimes || 0 }}条政策</div>
			<div class="desc">每天大量与您企业相匹配的政策与您擦肩而过，错失万亿政策补贴</div>
      <img class="vip-logo" src="../../../assets/img/vip/permission_img05.png">
    </div>
		<div class="vip-btn-black vip-btn-black-max-radius" @click="goPage"><span>查看政策</span></div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'permission',
		props: {
			number: {
				type: Number,
				default: null
			}
		},
		data() {
			return {}
		},
		computed: {
			...mapGetters(['noVipPolicyDayVisitTimes'])
		},
		methods: {
			goPage() {
				this.$router.push('/home')
			},
		}
	};
</script>

<style lang="less" scoped>
	.permission {
		margin-top: 21px;
		padding: 0 16px;
		.permission-item{
			width: 343px;
			min-height: 129px;
			padding: 22px 16px 24px 16px;
			box-shadow:0px 0px 20px 0px rgba(0,0,0,0.05);
			border-radius:5px;
			margin-bottom: 16px;
			position: relative;
			display: flex;
			flex-direction: column;
			.title {
				font-size:16px;
				font-weight:500;
				line-height:22px;
			}
			.desc {
				width: 222px;
				font-size:12px;
				font-weight:400;
				font-family:PingFangSC-Regular,PingFang SC;
				line-height:18px;
				margin-top: 7px;
				color: @subBlack;
			}
      .vip-logo {
        width: 65px;
        height: 69px;
        position: absolute;
        top:27px;
        right: 29px;
      }
		}
		.permission-item:last-child{
			margin-bottom: 30px;
		}
		.permission-item1 {
			border:1px solid rgba(219,184,127,1);
			background-image: url('../../../assets/img/vip/permission_img03.png');
			background-size: 263px 70px;
			background-repeat: no-repeat;/*还有repeat-x,y等*/
			background-position: 58px 45px;
			.label {
				height: 27px;
				width: auto;
				position:absolute;
				left: -1px;
				top: -13px;
			}
		}
		.permission-item2 {
			border:1px solid rgba(219,184,127,1);
			background-image: url('../../../assets/img/vip/permission_img04.png');
			background-size: 263px 70px;
			background-repeat: no-repeat;/*还有repeat-x,y等*/
			background-position: 58px 45px;

			.title {
				color: @subBlack;
			}
			border:1px solid rgba(220,220,220,1);
			color: @subBlack;
		}
		.vip-btn-black {
			margin-top: 30px;
		}
	}

</style>
